import React, { useEffect, useState } from 'react';
import { FaStar } from 'react-icons/fa';
import { Link } from 'react-router-dom';



const ServicesSection = () => {

    const [services, setServices] = useState([]);

    useEffect(() => {
        fetch('https://my-portfolio-server-wine-six.vercel.app/services')
            .then(res => res.json())
            .then(data => setServices(data));
    }, [])

    return (

        <div className="max-w-7xl mx-auto px-6 py-20">
            <div className='text-center mb-20'>
                <h3 className="text-xs md:text-sm xl:text-md font-semibold  tracking-widest mb-4 text-[#ff014f] uppercase">VISIT MY SERVICES AND CHOOSE ANY SERVICE</h3>
                <h1 className='text-5xl md:text-6xl xl:text-7xl font-bold'>My Services</h1>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5'>
                {
                    services.slice(0, 4).map(service => <Link className='col-span-1' key={service._id} to={`/services/${ service._id }`}>
                        <div className="card flex flex-col shadow-lg shadow-slate-600">
                            <figure><img className="h-48 w-full" src={service?.slide1} alt="Shoes" /></figure>
                            <div className="p-5">
                                <div className='flex gap-5 items-center'>
                                    <div className="avatar online">
                                        <div className="w-10 h-10 rounded-full">
                                            <img src="https://i.ibb.co/dD7d8Kj/shijan.jpg" alt='' />
                                        </div>
                                    </div>
                                    <div>
                                        <h2 className='text-md'>Md Shijan Ali</h2>
                                        <h2 className="text-[#FFBE5B] text-md font-semibold">Top Rated Seller</h2>
                                    </div>
                                </div>

                                <p className='text-md mt-5'>{service?.title.slice(0, 60)}...</p>
                                <div className="divider mt-10 "></div>
                                <div className='flex items-center justify-between'>
                                    <div className='flex items-center gap-2'>
                                        <FaStar className='text-[#FFBE5B]'></FaStar>
                                        <p><span className='text-[#FFBE5B]'> 5.0</span> ({service?.review})</p>
                                    </div>

                                    <div>
                                        <p>STARTING AT ${service?.pricingDetails?.basic?.price}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Link>
                    )
                }
            </div>

            <div className='mt-20 text-center'>
                <Link to='/services'>
                    <button className="btn w-52">View All</button>
                </Link>
            </div>
            <div className="divider mt-20"></div>
        </div>
    );
};

export default ServicesSection;